import CalculatorsController from '../../src/javascripts/cvm';
import SymplrGrc from '../../src/javascripts/models/symplr/grc';
import '../../src/javascripts/helpers/application/fa_checkbox_helper';
// import '../../src/javascripts/helpers/application/self_service_pdf_launcher';
import '../../src/javascripts/helpers/symplr/grc/hubspot_helpers';
import '../../src/javascripts/helpers/symplr/grc/fte_managing_compliance_calculator';
import '../../src/javascripts/helpers/symplr/grc/fte_managing_contract_calculator';
import '../../src/javascripts/helpers/symplr/grc/assumed_impact_of_reputational_dmg_calculator';
import '../../src/javascripts/helpers/symplr/grc/product_selection_dependencies';
import '../../src/javascripts/helpers/symplr/grc/investment_calculations';
import '../../src/stylesheets/symplr/symplr_shared.scss';
import '../../src/stylesheets/symplr/grc.scss';

(function() {
  $(() => CalculatorsController.run(new SymplrGrc()));
}).call(this);
